import { useTheme } from "@mui/material";
import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { API_PATHS } from "../API_App";
import { AppState } from "../../redux/reducer";
import { useConfirmDialog } from "../components/ConfirmDialogProvider";
import { useWarningDialog } from "../components/WarningDialogProvider";
import { some, SUCCESS_CODE } from "../constants";
import {
  NotifyProps,
  setLoading,
  setOpenNotify,
} from "../reducer/commonReducer";
import { fetchThunk } from "../reducer/thunk";

interface OptionsSnackbarObject extends Omit<OptionsObject, "variant"> {
  variant?: number | OptionsObject["variant"];
}

const useGeneralHook = () => {
  const dispatch: ThunkDispatch<AppState, null, AnyAction> = useDispatch();
  const appState = useSelector((state: AppState) => state);
  const theme = useTheme();
  const confirmDialog = useConfirmDialog();
  const warningDialog = useWarningDialog();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const intl = useIntl();
  const [state, setState] = useState<some>({});

  const setLoadingFnc = useCallback(
    (open: boolean) => {
      dispatch(setLoading(open));
    },
    [dispatch]
  );

  return {
    intl,
    dispatch,
    appState,
    enqueueSnackbar: (
      message?: SnackbarMessage,
      options?: OptionsSnackbarObject
    ) =>
      message &&
      enqueueSnackbar(message, {
        ...options,
        variant:
          typeof options?.variant === "number"
            ? options?.variant === SUCCESS_CODE
              ? "success"
              : "error"
            : options?.variant || "info",
      }),
    closeSnackbar,
    openNotify: (val: Omit<NotifyProps, "isOpen">) =>
      dispatch(setOpenNotify(val)),
    theme,
    confirmDialog,
    warningDialog,
    location,
    navigate: navigate,
    fetchThunk: fetchThunk,
    API_PATHS: API_PATHS,
    setLoading: setLoadingFnc,
    state,
    setState: (value: any) =>
      setState((old) => (value ? { ...old, ...value } : {})),
    isDarkTheme: theme.palette.mode === "dark",
  };
};

export default useGeneralHook;
